import { AxiosResponse } from 'axios';
import { SearchScopeEnum } from 'redux/search/types';

import APIService from '../apiUtils';
import ApiEndpoint from './apiEndpoint';

export default class SearchService {
  static async fetchSearch(
    searchInput: string,
    entities?: SearchScopeEnum[],
  ): Promise<Promise<AxiosResponse<string[]>>> {
    const searchInputParams: { searchInput?: string; entities?: string } = searchInput ? { searchInput } : {};
    if (entities) {
      searchInputParams.entities = entities.join(',');
    }
    return APIService.get<string[]>(ApiEndpoint.searchSuggestions, {
      params: searchInputParams,
    });
  }
}
